import React from "react";
import "../../pages/SignupPages/SignupCommon.css";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import padlockIcon from "../../assets/images/padlock.png";
import cvcIcon from "../../assets/images/cvcIcon.png";
import lockIcon from "../../assets/images/lockIcon.png";
import creditCardIcon from "../../assets/images/credit-card-icons.png";
import AlertIcon from "../../assets/images/alert.png";

export interface Props {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  billingAddressAddressLine1: string;
  billingAddressAddressLine2: string;
  billingAddressCity: string;
  billingAddressState: string;
  billingAddressZip: string;
  country: string;
  postcode: string;
  isCheckedTerms: boolean;
  firstNameError: string;
  lastNameError: string;
  emailError: string;
  phoneError: string;
  addressLine1Error: string;
  cityError: string;
  stateError: string;
  zipError: string;
  billingAddressAddressLine1Error: string;
  billingAddressCityError: string;
  billingAddressStateError: string;
  billingAddressZipError: string;
  isSubscribed: boolean;
  isVariant: boolean;
  isChecked: boolean;
  isCardValid: boolean;
  error: string;
  loading: boolean;
  stateOptions: Record<string, string>;
  onChange: (field: string, value: any) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCardNumberChange: (event: { complete: boolean }) => void;
  onCardExpiryChange: (event: { complete: boolean }) => void;
  onCardCvcChange: (event: { complete: boolean }) => void;
  handleChangeState?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleChangeBillingState?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onCheckboxChange?: () => void;
  nadPlusProduct?: boolean;
  disableAddress?: boolean;
}

const elementStyle = {
  style: {
    base: {
      fontSize: window.innerWidth > 600 ? "14px" : "16px",
      color: "#32325d",
    },
    invalid: { color: "#fa755a" },
  },
};

const CheckoutForm: React.FC<Props> = (props) => {
  const inputError = (error: string) =>
    error ? (
      <div className="checkout-state-error">
        <img src={AlertIcon} alt="state-error" width="16" height="15" />
        <p className="checkout-state-error-text">{error}</p>
      </div>
    ) : null;

  const disbaledBtn =
    !CardNumberElement ||
    !props.isCardValid ||
    !!props.firstNameError ||
    !!props.lastNameError ||
    !!props.emailError ||
    !!props.phoneError ||
    !!props.addressLine1Error ||
    !!props.cityError ||
    !!props.stateError ||
    !!props.zipError ||
    !!props.billingAddressAddressLine1Error ||
    !!props.billingAddressCityError ||
    !!props.billingAddressStateError ||
    !!props.billingAddressZipError || !props.isCheckedTerms


  return (
    <form onSubmit={props.onSubmit} className="checkout-container">
      <div
        className="checkout-features stripe-container"
        style={{ backgroundColor: "#fff" }}
      >
        <div>
          <h2 className="stripe-checkout-font">Account Details</h2>
          <div className="account-detail-container">
            <div className="state-zip-pacement">
              <div className="input-field-placement first-name">
                <label className="lable-font">First name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  className="field-styling"
                  style={{ backgroundColor: props.nadPlusProduct ?  "rgb(229, 237, 246)" : "" }}
                  disabled={props.nadPlusProduct ? true : false}
                  required
                  value={props.firstName}
                  onChange={(e) => props.onChange("firstName", e.target.value)}
                />
              </div>
              <div className="input-field-placement last-name">
                <label className="lable-font">Last name</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  className="field-styling"
                  style={{ backgroundColor: props.nadPlusProduct ?  "rgb(229, 237, 246)" : "" }}
                  disabled={props.nadPlusProduct ? true : false}
                  required
                  value={props.lastName}
                  onChange={(e) => props.onChange("lastName", e.target.value)}
                />
              </div>
            </div>
            {props.firstNameError && inputError(props.firstNameError)}
            {props.lastNameError && inputError(props.lastNameError)}
            <div className="input-field-placement">
              <label className="lable-font">Email</label>
              <input
                type="email"
                placeholder="Email Address"
                className="field-styling"
                style={{ backgroundColor: props.nadPlusProduct ?  "rgb(229, 237, 246)" : "" }}
                disabled={props.nadPlusProduct ? true : false}
                required
                value={props.email}
                onChange={(e) => props.onChange("email", e.target.value)}
              />
            </div>
            {props.emailError && inputError(props.emailError)}
            {!props.nadPlusProduct &&
            <>
            <div className="input-field-placement">
              <label className="lable-font">Phone</label>
              <input
                type="tel"
                placeholder="Phone number: (XXX) XXX-XXXX"
                className="field-styling"
                required
                value={props.phone}
                onChange={(e) => props.onChange("phone", e.target.value)}
              />
            </div>
            {props.phoneError && inputError(props.phoneError)}
            </>  
            } 
          </div>
        </div>
        <div>
          <h2 className="stripe-checkout-font">Shipping Address</h2>
          <div className="account-detail-container">
            <div className="input-field-placement">
              <label className="lable-font">Address line 1</label>
              <input
                type="text"
                placeholder="Address"
                className="field-styling"
                style={{ backgroundColor: props.disableAddress ?  "rgb(229, 237, 246)" : "" }}
                required
                value={props.addressLine1}
                disabled={props.disableAddress}
                onChange={(e) => props.onChange("addressLine1", e.target.value)}
              />
            </div>
            {props.addressLine1Error && inputError(props.addressLine1Error)}
            <div className="input-field-placement">
              <label className="lable-font">Address line 2</label>
              <input
                type="text"
                placeholder="Address"
                className="field-styling"
                style={{ backgroundColor: props.disableAddress ?  "rgb(229, 237, 246)" : "" }}
                value={props.addressLine2}
                disabled={props.disableAddress}
                onChange={(e) => props.onChange("addressLine2", e.target.value)}
              />
            </div>
            <div className="input-field-placement">
              <label className="lable-font">City</label>
              <input
                type="text"
                placeholder="City"
                className="field-styling"
                style={{ backgroundColor: props.disableAddress ?  "rgb(229, 237, 246)" : "" }}
                required
                value={props.city}
                disabled={props.disableAddress}
                onChange={(e) => props.onChange("city", e.target.value)}
              />
            </div>
            {props.cityError && inputError(props.cityError)}
            <div className="state-zip-pacement">
              <div className="input-field-placement">
                <label className="lable-font">State</label>
                <select
                  id="state"
                  name="state"
                  value={props.state}
                  style={{ backgroundColor: props.disableAddress ?  "rgb(229, 237, 246)" : "" }}
                  disabled={props.disableAddress || !!props.state}
                  onChange={props.handleChangeState} // Use the new handler
                  className="field-styling"
                >
                  <option value="">Select a state</option>
                  {Object.entries(props.stateOptions).map(
                    ([abbreviation, fullName]: [string, string]) => (
                      <option key={abbreviation} value={abbreviation}>
                        {fullName}
                      </option>
                    )
                  )}
                </select>
              </div>
              <div className="input-field-placement">
                <label className="lable-font">Zip</label>
                <input
                  type="text"
                  placeholder="Zip"
                  className="field-styling"
                  style={{ backgroundColor: props.disableAddress ?  "rgb(229, 237, 246)" : "" }}
                  required
                  value={props.zip}
                  disabled={props.disableAddress}
                  onChange={(e) => props.onChange("zip", e.target.value)}
                />
              </div>
            </div>
            {props.stateError && inputError(props.stateError)}
            {props.zipError && inputError(props.zipError)}
          </div>
        </div>
        <div>
          <h2 className="stripe-checkout-font">Billing Address</h2>
          <div className="input-field-placement-checkbox">
            <label>
              <input
                type="checkbox"
                checked={props.isChecked}
                onChange={props.onCheckboxChange}
                className="sameAsShippingText"
                style={{ cursor: "pointer" }}
              />
              Use a different billing address
            </label>
          </div>
          {props.isChecked && (
            <div className="account-detail-container">
              <div className="input-field-placement">
                <label className="lable-font">Address line 1</label>
                <input
                  type="text"
                  placeholder="Address"
                  className="field-styling"
                  required
                  value={
                    !props.isChecked
                      ? props.addressLine1
                      : props.billingAddressAddressLine1
                  }
                  onChange={(e) =>
                    props.onChange("billingAddressAddressLine1", e.target.value)
                  }
                />
              </div>
              {props.billingAddressAddressLine1Error &&
                inputError(props.billingAddressAddressLine1Error)}
              <div className="input-field-placement">
                <label className="lable-font">Address line 2</label>
                <input
                  type="text"
                  placeholder="Address"
                  className="field-styling"
                  value={
                    !props.isChecked
                      ? `${props.addressLine2}`
                      : `${props.billingAddressAddressLine2}`
                  }
                  onChange={(e) =>
                    props.onChange("billingAddressAddressLine2", e.target.value)
                  }
                />
              </div>
              <div className="input-field-placement">
                <label className="lable-font">City</label>
                <input
                  type="text"
                  placeholder="City"
                  className="field-styling"
                  required
                  value={
                    !props.isChecked
                      ? `${props.city}`
                      : `${props.billingAddressCity}`
                  }
                  onChange={(e) =>
                    props.onChange("billingAddressCity", e.target.value)
                  }
                />
              </div>
              {props.billingAddressCityError &&
                inputError(props.billingAddressCityError)}
              <div className="state-zip-pacement">
                <div className="input-field-placement">
                  <label className="lable-font">State</label>
                  <select
                    id="state"
                    name="state"
                    value={
                      !props.isChecked
                        ? `${props.state}`
                        : `${props.billingAddressState}`
                    }
                    onChange={props.handleChangeBillingState} // Use the new handler
                    className="field-styling"
                  >
                    <option value="">Select a state</option>
                    {Object.entries(props.stateOptions).map(
                      ([abbreviation, fullName]: [string, string]) => (
                        <option key={abbreviation} value={abbreviation}>
                          {fullName}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="input-field-placement">
                  <label className="lable-font">Zip</label>
                  <input
                    type="text"
                    placeholder="Zip"
                    className="field-styling"
                    required
                    value={
                      !props.isChecked
                        ? `${props.zip}`
                        : `${props.billingAddressZip}`
                    }
                    onChange={(e) =>
                      props.onChange("billingAddressZip", e.target.value)
                    }
                  />
                </div>
              </div>
              {props.billingAddressStateError &&
                inputError(props.billingAddressStateError)}
              {props.billingAddressZipError &&
                inputError(props.billingAddressZipError)}
            </div>
          )}
        </div>
        <div>
          <h2 className="stripe-checkout-font">
            <img
              src={padlockIcon}
              style={{ width: "15px", height: "15px", marginRight: "5px" }}
            />
            Payment Method
          </h2>
          <p className="transaction-line">
            All transactions are secure and encrypted.
          </p>
          <div className="account-detail-container">
            <div className="input-field-placement">
              <label
                className="stripe-card-fields lable-font"
                style={{ lineHeight: "18px" }}
              >
                Card number
                <div style={{ position: "relative" }}>
                  <CardNumberElement
                    options={elementStyle}
                    className="stripe-input field-styling content-center"
                    onChange={props.onCardNumberChange}
                  />
                  <img
                    src={creditCardIcon} // Replace with the path to your credit card icon
                    alt="Credit Card Icon"
                    style={{
                      position: "absolute",
                      right: "5px", // Adjust as needed
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "73px", // Adjust size as needed
                      height: "20px", // Adjust size as needed
                      cursor: "pointer", // Adjust size as needed
                    }}
                    className="credit-card-icon"
                  />
                </div>
              </label>
            </div>
            <div className="state-zip-pacement">
              <label
                className="stripe-card-fields lable-font"
                style={{ lineHeight: "18px" }}
              >
                Expiration date
                <CardExpiryElement
                  options={elementStyle}
                  className="stripe-input field-styling content-center box-width"
                  onChange={props.onCardExpiryChange}
                />
              </label>
              <div
                className="input-field-placement"
                style={{ position: "relative" }}
              >
                <label
                  className="stripe-card-fields lable-font"
                  style={{ lineHeight: "18px" }}
                >
                  Security code
                  <CardCvcElement
                    options={elementStyle}
                    className="stripe-input field-styling content-center box-width"
                    onChange={props.onCardCvcChange}
                  />
                </label>
                {/* Image positioned to the right of the CVC input */}
                <img src={cvcIcon} alt="CVC Info" className="cvc-icon" />
              </div>
            </div>
            <div className="state-zip-pacement">
              <label
                className="stripe-card-fields lable-font"
                style={{ lineHeight: "18px" }}
              >
                Country
                <select
                  value={props.country}
                  onChange={(e) => props.onChange("country", e.target.value)}
                  className="custom-input field-styling content-center box-width"
                >
                  <option value="">Select Country</option>
                  <option value="US">United States</option>
                </select>
              </label>

              <div
                className="input-field-placement"
                style={{ position: "relative" }}
              >
                <label
                  className="stripe-card-fields lable-font"
                  style={{ lineHeight: "18px" }}
                >
                  Postcode
                  <input
                    type="text"
                    value={props.postcode}
                    onChange={(e) => props.onChange("postcode", e.target.value)}
                    className="custom-input field-styling content-center box-width"
                    placeholder="Postcode"
                    maxLength={5}
                  />
                </label>
                <img src={cvcIcon} alt="Postcode Info" className="cvc-icon" />
              </div>
            </div>
          </div>
        </div>
        {props.nadPlusProduct && <div className="checkbox-row" style={{ margin: "0"}}>
            <input
              type="checkbox"
              id="agree"
              checked={props.isCheckedTerms}
              onChange={(e) =>
                props.onChange("isCheckedTerms", e.target.checked)
              }
              style={{ cursor: "pointer" }}
            />
            <label htmlFor="agree" className="agree-text">
              I AGREE TO THE{" "}
              <a
                href="https://claya.com/terms-of-use/"
                target="_blank"
                rel="noreferrer"
              >
                TERMS OF USE
              </a>
              ,{" "}
              <a
                href="https://claya.com/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                PRIVACY POLICY
              </a>
              , AND{" "}
              <a
                href="https://openloophealth.com/telehealth-consent/"
                target="_blank"
                rel="noreferrer"
              >
                TELEHEALTH CONSENT
              </a>
              , TO COMPLETE THE INTAKE FORM AFTER THE PURCHASE.
            </label>
          </div>}
        <button
          type="submit"
          className="pay-now-btn"
          disabled={disbaledBtn || props.loading}
          style={{
            backgroundColor:
              disbaledBtn || props.loading ? "#d3d3d3" : "#0c3972",
            cursor: props.loading ? "not-allowed" : "pointer",
            color: disbaledBtn || props.loading ? "white" : "white",
          }}
        >
          <img
            src={lockIcon}
            alt="Lock Icon"
            style={{
              marginRight: "6px",
              verticalAlign: "middle",
              width: "13px",
              height: "15px",
            }}
          />
          {props.loading ? "Processing..." : "COMPLETE PURCHASE"}
        </button>
        {props.nadPlusProduct && <div className="btn-suffix" style={{ marginTop: "-15px" }}>
              TRY IT RISK FREE! - LOSE 10% OF YOUR BODYWEIGHT OR YOUR MONEY BACK
            </div>}
        {props.error && <div className="error-message" style={{marginTop: '0px'}}>{props.error}</div>}
      </div>
    </form>
  );
};

export default CheckoutForm;
